<template>
  <canvas class="ai-groove-canvas" ref="aiGrooveCanvas"></canvas>
</template>
<script>
  export default {
    name: 'AiGroove',
    props: {
      height: {
        type: Number,
        default: 50
      },
    },
    data() {
      return {
        animationId: null,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.animateInit();
      });
    },
    beforeDestroy() {
      // 清除动画
      cancelAnimationFrame(this.animationId);
    },
    methods: {
      animateInit() {
        let canvas = this.$refs.aiGrooveCanvas;
        const ctx = canvas.getContext('2d');
        const width = canvas.width = window.innerWidth;
        const height = canvas.height = window.innerHeight;

        let waveCount = 3;
        let waveObjects = [];
        const colors = [
          'rgba(225, 93, 63, 0.6)', // 第一层颜色
          'rgba(254, 191, 93, 0.6)', // 第二层颜色
          'rgba(1, 229, 252, 0.6)' // 第三层颜色
        ];

        // 波浪对象
        class Wave {
          constructor(amplitude, frequency, phase, speed, color) {
            this.amplitude = amplitude;
            this.frequency = frequency;
            this.phase = phase;
            this.speed = speed;
            this.color = color; // 添加颜色属性
          }
          draw() {
            ctx.beginPath();
            for (let x = 0; x < width; x++) {
              let y = height / 2 + this.amplitude * Math.sin(this.frequency * x + this.phase);
              ctx.lineTo(x, y);
            }
            ctx.lineWidth = 20;
            ctx.strokeStyle = this.color; // 使用每个波浪的颜色
            ctx.stroke();
          }
        }

        // 创建波浪
        for (let i = 0; i < waveCount; i++) {
          let amplitude = (i + 1) * this.height * 2 * 0.6; // 高度
          let frequency = 0.01 * (i + 1);
          let phase = 0; // 初始相位
          let speed = 0.05 * 2; // 相位变化速度
          let color = colors[i % colors.length]; // 循环使用颜色数组
          waveObjects.push(new Wave(amplitude, frequency, phase, speed, color));
        }

        // 动画循环
        let _this = this

        function animate() {
          ctx.clearRect(0, 0, width, height);
          waveObjects.forEach(wave => {
            wave.phase += wave.speed; // 更新相位
            wave.draw();
          });
          _this.animationId = requestAnimationFrame(animate);
        }

        animate();
      },
    }
  }
</script>
<style lang="scss" scoped>
  .ai-groove-canvas {
    width: 100%;
    height: 100%;
  }
</style>